import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icons-16-line-add-hover",
  "use": "icon-icons-16-line-add-hover-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icons-16-line-add-hover\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M4 4h16v16H4z\" /><path d=\"M0 0h24v24H0z\" /><path d=\"M13 5v6h6v2h-6v6h-2v-6.001L5 13v-2l6-.001V5h2z\" fill=\"#005EE9\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol